import React, { FC } from "react";
import { Button } from "../index";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../config";
import Modal from "../Modal";
import { DialogProps } from "rc-dialog";

const tKeyStepCheckout = AppConfig.translationFileNames.step_Checkout;

export interface PopupConfirmProps extends DialogProps {
  onConfirm?: () => void;
  onClose?: () => void;
}
const Confirm: FC<PopupConfirmProps> = ({
  onConfirm,
  onClose,
  children,
  ...props
}) => {
  const { t } = useTranslation([tKeyStepCheckout]);

  const close = () => {
    onClose?.();
  };
  const onConfirmPress = () => {
    onClose?.();
    onConfirm?.();
  };

  return (
    <Modal width={400} onClose={close} {...props}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {});
        }
      })}

      <div style={{ marginTop: 10 }}>
        <div style={{ display: "inline" }}>
          <Button onClick={onConfirmPress} variant="primary">
            {t("step_Checkout:Confirm")}
          </Button>
        </div>
        <div style={{ display: "inline" }}>
          <Button onClick={close}>{t("step_Checkout:Cancel")}</Button>
        </div>
      </div>
    </Modal>
  );
};

export default Confirm;
